namespace TabAurous.Inventory {
    export namespace MaterialReturnItemsService {
        export const baseUrl = 'Purchase/MaterialReturnItems';

        export declare function Create(request: Serenity.SaveRequest<MaterialReturnItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<MaterialReturnItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<MaterialReturnItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<MaterialReturnItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function CustomList(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<MaterialReturnItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Purchase/MaterialReturnItems/Create",
            Update = "Purchase/MaterialReturnItems/Update",
            Delete = "Purchase/MaterialReturnItems/Delete",
            Retrieve = "Purchase/MaterialReturnItems/Retrieve",
            List = "Purchase/MaterialReturnItems/List",
            CustomList = "Purchase/MaterialReturnItems/CustomList"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'CustomList'
        ].forEach(x => {
            (<any>MaterialReturnItemsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
